"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArtworkSaleMessageContainer = exports.ArtworkSaleMessageQueryRenderer = exports.ArtworkSaleMessageQueryString = exports.ArtworkSaleMessage = void 0;

require("core-js/modules/es6.string.trim");

var _react = _interopRequireDefault(require("react"));

var Artsy = _interopRequireWildcard(require("../../../Artsy"));

var _reactRelay = require("react-relay");

var _get = require("../../../Utils/get");

var _ArtworkSaleMessageQuery;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArtworkSaleMessage = function ArtworkSaleMessage(props) {
  var bidInfo = function bidInfo(artwork) {
    var sale = artwork.sale;
    var inRunningAuction = sale && sale.isAuction && !sale.isClosed;

    if (!inRunningAuction) {
      return undefined;
    }

    var bidderPositionCounts = (0, _get.get)(artwork, function (a) {
      return a.saleArtwork.counts.bidderPositions;
    }, 0);

    if (bidderPositionCounts === 0) {
      return undefined;
    }

    var s = bidderPositionCounts > 1 ? "s" : "";
    return "(".concat(bidderPositionCounts, " bid").concat(s, ")");
  };

  var saleMessageDisplay = function saleMessageDisplay(artwork) {
    var sale = artwork.sale,
        saleMessage = artwork.saleMessage;
    var isAuction = sale && sale.isAuction;

    if (saleMessage === null) {
      return "";
    }

    if (isAuction) {
      var showBiddingClosed = sale.isClosed;

      if (showBiddingClosed) {
        return "Bidding closed";
      } else {
        var highestBidDisplay = (0, _get.get)(artwork, function (p) {
          return p.saleArtwork.highestBid.display;
        });
        var openingBidDisplay = (0, _get.get)(artwork, function (p) {
          return p.saleArtwork.openingBid.display;
        });
        return highestBidDisplay || openingBidDisplay || "";
      }
    }

    return saleMessage === "Contact For Price" ? "Contact for price" : saleMessage;
  };

  var artwork = props.artwork;
  var saleMessage = "".concat(saleMessageDisplay(artwork), " ").concat(bidInfo(artwork) || "").trim();
  return _react.default.createElement("span", {
    key: "artworkSaleMessage"
  }, saleMessage);
};

exports.ArtworkSaleMessage = ArtworkSaleMessage;
var ArtworkSaleMessageQueryString = _ArtworkSaleMessageQuery !== void 0 ? _ArtworkSaleMessageQuery : (_ArtworkSaleMessageQuery = require("../../../__generated__/ArtworkSaleMessageQuery.graphql"), _ArtworkSaleMessageQuery.hash && _ArtworkSaleMessageQuery.hash !== "02a606b1af7ad3c72aa9e7fa4064577b" && console.error("The definition of 'ArtworkSaleMessageQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _ArtworkSaleMessageQuery);
exports.ArtworkSaleMessageQueryString = ArtworkSaleMessageQueryString;

var ArtworkSaleMessageQueryRenderer = function ArtworkSaleMessageQueryRenderer(props) {
  var artworkSlug = props.artworkSlug,
      relayEnvironment = props.relayEnvironment;
  return _react.default.createElement(_reactRelay.QueryRenderer, {
    environment: relayEnvironment,
    query: ArtworkSaleMessageQueryString,
    variables: {
      artworkSlug: artworkSlug
    },
    render: function render(readyState) {
      var _readyState$props;

      var artwork = readyState === null || readyState === void 0 ? void 0 : (_readyState$props = readyState.props) === null || _readyState$props === void 0 ? void 0 : _readyState$props.artwork;
      return artwork ? _react.default.createElement(ArtworkSaleMessage, {
        artwork: artwork
      }) : null;
    }
  });
};

exports.ArtworkSaleMessageQueryRenderer = ArtworkSaleMessageQueryRenderer;
var ArtworkSaleMessageContainer = Artsy.withSystemContext(ArtworkSaleMessageQueryRenderer);
exports.ArtworkSaleMessageContainer = ArtworkSaleMessageContainer;
//# sourceMappingURL=ArtworkSaleMessage.js.map